import React from 'react';
import { ProjectList } from './components/ProjectList';
export function App() {
  return <div className="w-full min-h-screen bg-background" data-id="element-0">
      <header className="border-b py-4 px-6" data-id="element-1">
        <div className="max-w-7xl mx-auto" data-id="element-2">
          <h1 className="text-2xl font-bold" data-id="element-3">Mes Projets</h1>
        </div>
      </header>
      <main className="max-w-7xl mx-auto py-8 px-6" data-id="element-4">
        <ProjectList data-id="element-5" />
      </main>
    </div>;
}